<template>
    <b-table
            :data="data"
            :paginated="true"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :striped="true"
            :loading="loading"
            default-sort="productionDate"
            default-sort-direction="desc">

            <template slot-scope="props">

                <b-table-column field="productionDate" label="Oppgjørsdato" sortable>
                    {{ props.row.productionDate | moment("D. MMM YYYY") }}
                </b-table-column>

                <b-table-column field="loadAmount" label="Varekjøp beløp" numeric sortable>
                    {{ props.row.loadAmount | currency }}
                </b-table-column>

                <b-table-column field="noOfLoads" label="Ant. varekjøp" numeric sortable>
                    {{ props.row.noOfLoads }}
                </b-table-column>

                <b-table-column field="purchaseAmount" label="Innskudd" numeric sortable>
                    {{ props.row.purchaseAmount | currency }}
                </b-table-column>

                <b-table-column field="noOfPurchases" label="Ant. innskudd" numeric sortable>
                    {{ props.row.noOfPurchases }}
                </b-table-column>
                
            </template>

            <template slot="footer">
                <th>
                    <div class="th-wrap">Sum totalt</div>
                </th>
                <th>
                    <div class="th-wrap is-numeric">{{ totals.totalLoadAmount | currency }}</div>
                </th>

                <th>
                    <div class="th-wrap is-numeric">{{ totals.totalLoads }}</div>
                </th>

                <th>
                    <div class="th-wrap is-numeric">{{ totals.totalPurchaseAmount | currency }}</div>
                </th>

                <th>
                    <div class="th-wrap is-numeric">{{ totals.totalNoOfPurchases }}</div>
                </th>

            </template>

        </b-table>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    props: ['viewSource'],
    data () {
        return {
            perPage: 31,
            currentPage: 1,
            monthNames: ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'],
            dayNames: ['S', 'M', 'Ti', 'O', 'To', 'F', 'L'],
        }
    },
    computed: {
        ...mapGetters('reports', ['data', 'loading', 'totals', 'groupData'])
    },
    methods: {
        ...mapActions('reports', ['setBax']),
        requestBax (bax) {
            if (this.$store.state.reports.bax === '') {
                this.$router.push({query: {...this.$route.query, bax: bax}})
                this.setBax(bax)
            } else {
                // eslint-disable-next-line
                const { bax, ...rest } = this.$route.query
                this.$router.replace({'query': rest})
                this.setBax('')
            }
        },
    }

}
</script>

<style>

</style>
